import { useNavigate } from "react-router-dom";
import { Input } from "shared/ui/Input";
import { Button } from "shared/ui/button";
import { useUserStore } from "entities/user";
import { logoutUser } from "../../model/logoutUser";
import { HOME_ROUTE } from "shared/config/routes";
import styles from "./Profile.module.scss";

export const ClientProfile = () => {
  const navigate = useNavigate();
  const { user } = useUserStore();

  const handleLogout = async () => {
    await logoutUser();
    navigate(HOME_ROUTE);
  };
  return (
    <div className={styles.formWrapper}>
      <div className={styles.formWrapper__form}>
        <div className={styles.formWrapper__formItem}>
          <p className={styles.formWrapper__label}>Наименование организации</p>
          <Input
            type="text"
            placeholder={user?.companyName}
            className={styles.formWrapper__input}
            disabled={true}
          />
        </div>

        <div className={styles.formWrapper__formItem}>
          <p className={styles.formWrapper__label}>ФИО</p>
          <Input
            type="text"
            placeholder={user?.fio}
            className={styles.formWrapper__input}
            disabled={true}
          />
        </div>

        <div className={styles.formWrapper__formItem}>
          <p className={styles.formWrapper__label}>Номер телефона</p>
          <Input
            type="text"
            placeholder={user?.phoneNumber}
            className={styles.formWrapper__input}
            disabled={true}
          />
        </div>

        <div className={styles.formWrapper__formItem}>
          <p className={styles.formWrapper__label}>Электронная почта</p>
          <Input
            type="text"
            placeholder={user?.email}
            className={styles.formWrapper__input}
            disabled={true}
          />
        </div>
      </div>

      <div className={styles.formWrapper__buttonBlock}>
        <div className={styles.formWrapper__button}>
          <Button variant="outlineGreen" size="large" onClick={handleLogout}>
            Выйти
          </Button>
        </div>
      </div>
    </div>
  );
};
